import { render, staticRenderFns } from "./InvertedHeader.vue?vue&type=template&id=9aa4505e&scoped=true&"
import script from "./InvertedHeader.vue?vue&type=script&lang=js&"
export * from "./InvertedHeader.vue?vue&type=script&lang=js&"
import style0 from "./InvertedHeader.vue?vue&type=style&index=0&id=9aa4505e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa4505e",
  null
  
)

export default component.exports